export default __webpack_public_path__ + "static/media/download.9601864d.png";